import { toast } from 'sonner';
import { z } from 'zod';

import { useCreateSupplierMutation } from '@/features/slice/suppliers';
import { useModal } from '@/hooks';
import { logError } from '@/utils';

import { SupplierFormSchema } from './create-supplier.schema';

export const useCreateSupplier = () => {
    const [createSupplier, { isLoading, isSuccess }] =
        useCreateSupplierMutation();

    const { closeModal } = useModal();

    const onSubmit = async (value: z.infer<typeof SupplierFormSchema>) => {
        try {
            await createSupplier(value).unwrap();

            closeModal();
            toast.success('Successfully added new supplier.');
        } catch (error) {
            logError('useCreateSupplier', error);
            toast.error('Failed to add supplier. Please try again.');
        }
    };

    return {
        onSubmit,
        isLoading,
        isSuccess,
    };
};
